var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
    },
    [
      _c("mini-header", {
        key: _vm.resetTab,
        attrs: {
          list: _vm.statusTab,
          filter: _vm.filter,
          status: _vm.basicStatusTab,
          breadcrumbs: _vm.breadcrumbs,
          hiddenTab: !_vm.$helpers.hasSomePermission(["view_summary"]),
          scroll: _vm.scroll,
        },
        on: {
          "update:filter": function ($event) {
            _vm.filter = $event
          },
        },
        scopedSlots: _vm._u(
          [
            _vm.$helpers.hasSomePermission(["view_summary"])
              ? {
                  key: "main",
                  fn: function () {
                    return [
                      _c(
                        "v-btn",
                        {
                          attrs: { outlined: "", disabled: !_vm.count },
                          on: { click: _vm.getList },
                        },
                        [
                          _c("v-img", {
                            attrs: {
                              contain: "",
                              src: require(`@/assets/icon-update${
                                _vm.$vuetify.theme.dark ? "-dark" : ""
                              }.svg`),
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            "close-on-click": "",
                            "close-on-content-click": "",
                            "offset-y": "",
                            left: "",
                            "nudge-bottom": 10,
                            transition: "slide-y-transition",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "ml-2",
                                            attrs: { outlined: "" },
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c("v-icon", { attrs: { left: "" } }, [
                                          _vm._v("mdi-plus-box "),
                                        ]),
                                        _vm._v("Opciones"),
                                        _c(
                                          "v-icon",
                                          { attrs: { size: "18", right: "" } },
                                          [_vm._v("mdi-chevron-down")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3671956459
                          ),
                        },
                        [
                          _c(
                            "v-list",
                            { staticClass: "pa-0" },
                            [
                              _c(
                                "v-list-item",
                                {
                                  staticClass: "px-3",
                                  attrs: {
                                    disabled: !_vm.count,
                                    ripple: false,
                                  },
                                  on: { click: _vm.createDownloadList },
                                },
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "body-1 grey-300--text" },
                                    [_vm._v("Descargar listado")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-query-builder", {
                        staticClass: "ml-2",
                        attrs: {
                          "query-map": _vm.filters,
                          model: "documents",
                          active: _vm.activeFilter,
                        },
                        on: {
                          "update:active": function ($event) {
                            _vm.activeFilter = $event
                          },
                        },
                      }),
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            "close-on-click": "",
                            "close-on-content-click": "",
                            "offset-y": "",
                            left: "",
                            "nudge-bottom": 10,
                            transition: "slide-y-transition",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _vm.$helpers.hasSomePermission([
                                      "add_summary",
                                    ])
                                      ? _c(
                                          "v-btn",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "ml-2",
                                                attrs: { color: "grey-900" },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { left: "" } },
                                              [_vm._v("mdi-plus-box ")]
                                            ),
                                            _vm._v("Crear proceso"),
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  size: "18",
                                                  right: "",
                                                },
                                              },
                                              [_vm._v("mdi-chevron-down")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            851218349
                          ),
                        },
                        [
                          _c(
                            "v-list",
                            { staticClass: "pa-0" },
                            [
                              _c(
                                "v-list-item",
                                {
                                  staticClass: "px-3",
                                  attrs: { ripple: false },
                                  on: {
                                    click: function ($event) {
                                      ;(_vm.currentReport =
                                        "Informe de reversiones"),
                                        (_vm.dialogCreate = true)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "body-1 grey-500--text" },
                                    [_vm._v("Informe de reversiones")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                {
                                  staticClass: "px-3",
                                  attrs: { ripple: false },
                                  on: {
                                    click: function ($event) {
                                      ;(_vm.currentReport = "Informe de bajas"),
                                        (_vm.dialogCreate = true)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "body-1 grey-500--text" },
                                    [_vm._v("Informe de bajas")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                {
                                  staticClass: "px-3",
                                  attrs: { ripple: false },
                                  on: {
                                    click: function ($event) {
                                      ;(_vm.currentReport =
                                        "Informe de bajas de boletas"),
                                        (_vm.dialogCreate = true)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "body-1 grey-500--text" },
                                    [_vm._v("Informe de bajas de boletas")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
      }),
      _c(
        "v-col",
        { staticClass: "px-0 mt-25 pb-10", attrs: { cols: "12" } },
        [
          _c("documents-list", {
            key: _vm.reset,
            attrs: {
              "show-create": true,
              selectedDocuments: _vm.selectedDocuments,
              toggleDropdown: _vm.toggleDropdown,
              headerList: _vm.headers,
              pageSize: _vm.pageSize,
            },
            on: {
              activeBtnFilter: function ($event) {
                _vm.activeFilter = true
              },
              "update:selectedDocuments": function ($event) {
                _vm.selectedDocuments = $event
              },
              "update:selected-documents": function ($event) {
                _vm.selectedDocuments = $event
              },
              "update:toggleDropdown": function ($event) {
                _vm.toggleDropdown = $event
              },
              "update:toggle-dropdown": function ($event) {
                _vm.toggleDropdown = $event
              },
              getList: _vm.getList,
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "700",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogExport,
            callback: function ($$v) {
              _vm.dialogExport = $$v
            },
            expression: "dialogExport",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Descarga de documentos emitidos")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogExport = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "px-5 py-2" },
                [
                  _c(
                    "v-list",
                    { staticClass: "pa-0 transparent" },
                    [
                      _c(
                        "v-list-item",
                        { staticClass: "mt-2" },
                        [
                          _c(
                            "v-list-item-content",
                            { staticClass: "pt-0" },
                            [
                              _c(
                                "v-list-item-title",
                                {
                                  staticClass:
                                    "grey-500--text body-1 font-weight-semibold",
                                },
                                [
                                  _vm._v(
                                    "Selecciona el formato de los archivos:"
                                  ),
                                ]
                              ),
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "pt-2" },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "ml-n1",
                                      attrs: { "no-gutters": "" },
                                    },
                                    _vm._l(_vm.fileFormat, function (file) {
                                      return _c(
                                        "v-col",
                                        {
                                          key: file,
                                          staticClass: "pa-0",
                                          attrs: { cols: "6" },
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "ma-0 vcheckbox",
                                            attrs: {
                                              "input-value":
                                                _vm.types.includes(file) ||
                                                false,
                                              column: "",
                                              label: file,
                                              disabled:
                                                ["XLSX", "CSV", "XML"].includes(
                                                  file
                                                ) && _vm.count >= 1000000,
                                              dense: "",
                                              "hide-details": "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.getFileFormat(file)
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-alert",
                    {
                      staticClass:
                        "inf-alert-blue green-500--text rounded-md mt-2",
                      attrs: { height: 58, dense: "", text: "" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex pa-0 my-1" },
                        [
                          _c(
                            "v-icon",
                            { attrs: { color: "grey-900", size: "22" } },
                            [_vm._v("mdi-information-outline")]
                          ),
                          _c("div", { staticClass: "ml-4" }, [
                            _c(
                              "span",
                              {
                                staticClass: "body-2",
                                staticStyle: { "line-height": "14px" },
                              },
                              [
                                _vm._v("Esta acción "),
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("podría tardar varios minutos")]
                                ),
                                _vm._v(" en completarse. Recibirás un "),
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold" },
                                  [
                                    _vm._v(
                                      " correo electrónico con el enlace de descarga."
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "", ripple: false },
                      on: {
                        click: function ($event) {
                          _vm.dialogExport = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        ripple: false,
                        disabled: !_vm.types.length,
                      },
                      on: { click: _vm.createExport },
                    },
                    [_vm._v("Descargar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "700",
            persistent: "",
            "no-click-animation": "",
            scrollable: "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.sendEmailDialog,
            callback: function ($$v) {
              _vm.sendEmailDialog = $$v
            },
            expression: "sendEmailDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Enviar documento por email")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.sendEmailDialog = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pa-0" },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "transparent rounded-0 pa-0",
                          attrs: { flat: "" },
                        },
                        [
                          _c(
                            "v-card-subtitle",
                            { staticClass: "background pt-5 pb-3 px-5" },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex align-center" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "grey-500--text body-1",
                                      staticStyle: { "min-width": "60px" },
                                    },
                                    [_vm._v("Para")]
                                  ),
                                  _c("v-combobox", {
                                    staticClass: "a-combobox",
                                    attrs: {
                                      "hide-details": "",
                                      items: _vm.sendEmailList,
                                      "item-value": "id",
                                      "item-text": "name",
                                      chips: "",
                                      "small-chips": "",
                                      multiple: "",
                                      outlined: "",
                                      required: "",
                                      "hide-selected": "",
                                      "hide-no-data": "",
                                      "single-line": "",
                                      dense: "",
                                      autocomplete: "off",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "selection",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "v-chip",
                                              _vm._b(
                                                {
                                                  staticClass:
                                                    "pr-2 close-chip",
                                                  attrs: {
                                                    color: "green-100",
                                                    small: "",
                                                    "input-value":
                                                      data.selected,
                                                    close: "",
                                                  },
                                                  on: {
                                                    click: data.select,
                                                    "click:close": function (
                                                      $event
                                                    ) {
                                                      return _vm.remove(
                                                        data.item
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-chip",
                                                data.attrs,
                                                false
                                              ),
                                              [_vm._v(_vm._s(data.item.name))]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                    model: {
                                      value: _vm.messages.recipient,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.messages, "recipient", $$v)
                                      },
                                      expression: "messages.recipient",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "d-flex align-center mt-3" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "grey-500--text body-1",
                                      staticStyle: { "min-width": "60px" },
                                    },
                                    [_vm._v("Asunto")]
                                  ),
                                  _c("v-text-field", {
                                    attrs: {
                                      outlined: "",
                                      required: "",
                                      "single-line": "",
                                      dense: "",
                                      maxlength: "60",
                                      "persistent-hint": "",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.messages.subject,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.messages, "subject", $$v)
                                      },
                                      expression: "messages.subject",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "pa-0 mt-2" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "grey-500--text body-1 mr-5",
                                    },
                                    [_vm._v("Archivos adjuntos")]
                                  ),
                                  _c(
                                    "v-chip",
                                    {
                                      staticClass: "ma-1 pl-1 pr-2",
                                      attrs: {
                                        color: "grey-700",
                                        small: "",
                                        outlined: "",
                                        label: "",
                                      },
                                    },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "ma-0 pb-1",
                                        attrs: {
                                          value: "pdf",
                                          dense: "",
                                          "hide-details": "",
                                        },
                                        model: {
                                          value: _vm.messages.type,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.messages, "type", $$v)
                                          },
                                          expression: "messages.type",
                                        },
                                      }),
                                      _c(
                                        "v-icon",
                                        { attrs: { left: "", size: "14" } },
                                        [_vm._v("mdi-paperclip")]
                                      ),
                                      _vm._v("*.pdf "),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-chip",
                                    {
                                      staticClass: "ma-1 pl-1 pr-2",
                                      attrs: {
                                        color: "grey-700",
                                        small: "",
                                        outlined: "",
                                        label: "",
                                      },
                                    },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "ma-0 pb-1",
                                        attrs: {
                                          value: "xml",
                                          dense: "",
                                          "hide-details": "",
                                        },
                                        model: {
                                          value: _vm.messages.type,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.messages, "type", $$v)
                                          },
                                          expression: "messages.type",
                                        },
                                      }),
                                      _c(
                                        "v-icon",
                                        { attrs: { left: "", size: "14" } },
                                        [_vm._v("mdi-paperclip")]
                                      ),
                                      _vm._v("*.xml "),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("v-divider"),
                          _c(
                            "v-card-text",
                            {
                              staticClass:
                                "pa-0 pb-4 mx-auto bgPanel overflow-y-auto text-center",
                              staticStyle: { "max-height": "450px" },
                            },
                            [
                              _c(
                                "v-alert",
                                {
                                  staticClass: "inf-alert green-500--text",
                                  attrs: {
                                    height: 50,
                                    dense: "",
                                    text: "",
                                    outlined: "",
                                    color: "#BED2F0",
                                    tile: "",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex px-2 py-0" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            color: "grey-900",
                                            size: "26",
                                          },
                                        },
                                        [_vm._v("mdi-information")]
                                      ),
                                      _c("div", { staticClass: "ml-4 py-1" }, [
                                        _c("span", { staticClass: "body-1" }, [
                                          _vm._v(
                                            "Esta es una vista previa del documento N° " +
                                              _vm._s(
                                                (_vm.selectedDocuments[0] || [])
                                                  .number
                                              ) +
                                              "."
                                          ),
                                        ]),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c("v-alert", {
                                staticClass: "pa-0 mt-6 mx-auto",
                                style: `width: ${
                                  _vm.$vuetify.breakpoint.width < 1270
                                    ? 465
                                    : 564
                                }px;`,
                                attrs: {
                                  border: "top",
                                  color: "var(--light-blue-500)",
                                  "colored-border": "",
                                  elevation: "0",
                                },
                              }),
                              _c(
                                "v-sheet",
                                {
                                  staticClass: "mx-auto",
                                  staticStyle: {
                                    "border-radius": "10px",
                                    "margin-top": "-17px",
                                  },
                                  attrs: {
                                    width:
                                      _vm.$vuetify.breakpoint.width < 1270
                                        ? 467
                                        : 566,
                                    outlined: "",
                                  },
                                },
                                [
                                  _vm.selectedDocuments
                                    ? _c("reminder-documents-email", {
                                        attrs: {
                                          instance: _vm.selectedDocuments[0],
                                          activeDocument: _vm.activeDocument(
                                            (_vm.selectedDocuments[0] || [])
                                              .document_type || {}
                                          ),
                                          message: _vm.messages.text,
                                        },
                                        on: {
                                          "update:message": function ($event) {
                                            return _vm.$set(
                                              _vm.messages,
                                              "text",
                                              $event
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("v-divider"),
                          _c(
                            "v-card-actions",
                            { staticClass: "py-4 px-5" },
                            [
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  attrs: { outlined: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.sendEmailDialog = false
                                    },
                                  },
                                },
                                [_vm._v("Cancelar")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    loading:
                                      _vm.$store.state.messages.createLoader,
                                    color: "grey-900",
                                  },
                                  on: { click: _vm.createMail },
                                },
                                [_vm._v("Enviar")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: 680, persistent: "", "no-click-animation": "" },
          model: {
            value: _vm.dialogCreate,
            callback: function ($$v) {
              _vm.dialogCreate = $$v
            },
            expression: "dialogCreate",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-700--text font-weight-semibold",
                        },
                        [_vm._v("Crear nuevo proceso")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      ;(_vm.dialogCreate = false), _vm.clear()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "px-0 py-4" },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "pt-2 pb-2",
                      attrs: { align: "center", "no-gutters": "" },
                    },
                    [
                      _c(
                        "v-col",
                        { staticClass: "px-5", attrs: { cols: "3" } },
                        [
                          _c("img", {
                            attrs: {
                              src: require(`@/assets/backgrounds/modal-folios-upload.svg`),
                              height: 220,
                            },
                          }),
                        ]
                      ),
                      _c(
                        "v-col",
                        { staticClass: "pr-5 pl-16" },
                        [
                          _c(
                            "v-list",
                            { staticClass: "v-list-form pa-0 transparent" },
                            [
                              _c(
                                "v-list-item",
                                { staticClass: "py-0" },
                                [
                                  _c("v-list-item-title", [
                                    _vm._v("Tipo de documento"),
                                  ]),
                                  _c(
                                    "v-list-item-subtitle",
                                    { staticClass: "ml-n12" },
                                    [_vm._v(_vm._s(_vm.currentReport))]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { staticClass: "py-2" },
                                [
                                  _c("v-list-item-title", [
                                    _vm._v("Razón social"),
                                  ]),
                                  _c(
                                    "v-list-item-subtitle",
                                    { staticClass: "ml-n12" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store?.state?.auth?.account
                                            ?.name || ""
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { staticClass: "py-0" },
                                [
                                  _c("v-list-item-title", [_vm._v("Fecha")]),
                                  _c(
                                    "v-list-item-subtitle",
                                    { staticClass: "ml-n12" },
                                    [
                                      _c(
                                        "v-menu",
                                        {
                                          attrs: {
                                            "close-on-content-click": false,
                                            "offset-x": "",
                                            "nudge-bottom": -10,
                                            transition: "slide-y-transition",
                                            "max-width": "290",
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function ({ on, attrs }) {
                                                return [
                                                  _c(
                                                    "v-text-field",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          attrs: {
                                                            error:
                                                              _vm.$v
                                                                .reversalsReport
                                                                .extra_data
                                                                .periodo.$error,
                                                            "append-icon":
                                                              "mdi-calendar-month",
                                                            outlined: "",
                                                            "single-line": "",
                                                            dense: "",
                                                            readonly: "",
                                                            "hide-details": "",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.$v
                                                                .reversalsReport
                                                                .extra_data
                                                                .periodo.$model,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.$v
                                                                  .reversalsReport
                                                                  .extra_data
                                                                  .periodo,
                                                                "$model",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "$v.reversalsReport.extra_data.periodo.$model",
                                                          },
                                                        },
                                                        "v-text-field",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    )
                                                  ),
                                                ]
                                              },
                                            },
                                          ]),
                                          model: {
                                            value: _vm.dateMenu,
                                            callback: function ($$v) {
                                              _vm.dateMenu = $$v
                                            },
                                            expression: "dateMenu",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-date-picker",
                                            {
                                              attrs: {
                                                min: "2020-01-01",
                                                "no-title": "",
                                                "first-day-of-week": 1,
                                                type: "date",
                                                locale: "es",
                                                "max-width": "270",
                                                color: "grey-900",
                                              },
                                              on: {
                                                input: function ($event) {
                                                  _vm.dateMenu = false
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.$v.reversalsReport
                                                    .extra_data.periodo.$model,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.$v.reversalsReport
                                                      .extra_data.periodo,
                                                    "$model",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "$v.reversalsReport.extra_data.periodo.$model",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-row",
                                                {
                                                  staticClass: "mb-2 px-6",
                                                  attrs: {
                                                    align: "center",
                                                    justify: "end",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "body-1",
                                                      attrs: {
                                                        ripple: false,
                                                        text: "",
                                                        color: "grey-900",
                                                      },
                                                      on: {
                                                        click: () => {
                                                          _vm.reversalsReport.extra_data.periodo =
                                                            null
                                                          _vm.dateMenu = false
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Limpiar")]
                                                  ),
                                                  _c("v-spacer"),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        color: "grey-900",
                                                      },
                                                      on: {
                                                        click: () => {
                                                          _vm.$v.reversalsReport.extra_data.periodo.$model =
                                                            _vm.today
                                                          _vm.dateMenu = false
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Hoy")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("v-divider", { staticClass: "my-5" }),
                              _c(
                                "v-list-item",
                                { staticClass: "py-0" },
                                [
                                  _c("v-list-item-title", [_vm._v("Archivo")]),
                                  _c(
                                    "v-list-item-subtitle",
                                    { staticClass: "ml-n13" },
                                    [
                                      _c("v-file-input", {
                                        ref: "file",
                                        attrs: {
                                          error:
                                            _vm.$v.reversalsReport.doc_txt
                                              .$error,
                                          type: "file",
                                          accept: ".txt",
                                          prepend: "mdi-paper-clip",
                                          "hide-details": "",
                                          "background-color": "transparent",
                                          placeholder:
                                            "No se eligió ningún archivo",
                                          solo: "",
                                          flat: "",
                                          chips: "",
                                          dense: "",
                                        },
                                        model: {
                                          value:
                                            _vm.$v.reversalsReport.doc_txt
                                              .$model,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.$v.reversalsReport.doc_txt,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.reversalsReport.doc_txt.$model",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-4 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "", color: "grey-700" },
                      on: {
                        click: function ($event) {
                          ;(_vm.dialogCreate = false), _vm.clear()
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "grey-900" },
                      on: { click: _vm.createProcess },
                    },
                    [_vm._v("Iniciar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }